import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { environment } from "../../../environments/environment";
import { AuthService } from "../auth/auth.service";
import { ProjectService } from "../project/project.service";
import { HelpersService } from "../helper/helpers.service";
import { AlertError } from "../error-handler";

@Injectable({
    providedIn: "root"
})
export class RankingsService {
    constructor(
        private http: HttpClient,
        private authSvc: AuthService,
        private projectSvc: ProjectService,
        private helpersSvc: HelpersService
    ) {}

    topCompetencyGrantee(year = "", month = ""): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                }),

                params: {
                    year: year,
                    month: month
                }
            };

            const url = environment.urlDomain + "/api/v1/ranking/badgeGrantee";
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }

    topCompetencyGrantor(year = "", month = ""): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                }),

                params: {
                    year: year,
                    month: month
                }
            };

            const url = environment.urlDomain + "/api/v1/ranking/badgeGrantor";
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }

    topMisionGrantee(year = "", month = ""): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                }),

                params: {
                    year: year,
                    month: month
                }
            };

            const url = environment.urlDomain + "/api/v1/ranking/missionGrantee";
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }

    topMisionGrantor(year = "", month = ""): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                }),

                params: {
                    year: year,
                    month: month
                }
            };

            const url = environment.urlDomain + "/api/v1/ranking/missionGrantor";
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }

    topCompetencyHistory(): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                })
            };

            const url = environment.urlDomain + "/api/v1/ranking/historyGrantee";
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }

    topCompetencyGrantorHistory(): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                })
            };

            const url = environment.urlDomain + "/api/v1/ranking/historyGrantor";
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }

    userCompetencyHistory(): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                })
            };

            const url = environment.urlDomain + "/api/v1/ranking/userHistory";
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }

    coinsHistory(year = "", month = ""): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                }),

                params: {
                    year: year,
                    month: month
                }
            };

            const url = environment.urlDomain + "/api/v1/ranking/historyCoins";
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }

    totalHistory(): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                })
            };

            const url = environment.urlDomain + "/api/v1/ranking/totalData";
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }

    topPosts(year = "", month = ""): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                }),

                params: {
                    year: year,
                    month: month
                }
            };

            const url = environment.urlDomain + "/api/v1/ranking/posts";
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }

    topActivity(year = "", month = ""): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                }),

                params: {
                    year: year,
                    month: month
                }
            };

            const url = environment.urlDomain + "/api/v1/ranking/activity";
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }
}
